import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { toAbsoluteUrl } from "@/lib/imageUrl";
import { youtubeEmbedUrl, youtubeId } from "@/lib/youtube";

/** Embed URL from the video id (parsed, not string-replaced — links with &t=…&pp=… params used to produce a broken embed). */
const toEmbedUrl = (url) => { const id = youtubeId(url); return id ? youtubeEmbedUrl(id) : null; };

/**
 * Video lightbox — reused wherever a resource-listing card needs to play a
 * video inline instead of navigating away. Videos only ever autoplay here,
 * inside a modal the user explicitly opened by clicking; nothing autoplays
 * on page load.
 */
export default function VideoModal({ video, onClose }) {
  const embed = video ? toEmbedUrl(video.external_url) || toEmbedUrl(video.file_url) : null; // some resources keep the YouTube link in file_url
  const directSrc = video && !embed ? toAbsoluteUrl(video.file_url) : "";

  return (
    <Dialog open={!!video} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-4xl w-[92vw] p-0 bg-black border-none overflow-hidden [&>button]:text-white [&>button]:opacity-90 [&>button]:hover:opacity-100 [&>button]:z-10">
        <DialogTitle className="sr-only">{video?.title || "Video"}</DialogTitle>
        <div className="aspect-video w-full bg-black" data-testid="video-modal-player">
          {embed ? (
            <iframe
              key={embed}
              src={embed}
              title={video.title}
              allow="autoplay; fullscreen; encrypted-media"
              allowFullScreen
              className="w-full h-full"
            />
          ) : directSrc ? (
            <video key={directSrc} src={directSrc} poster={toAbsoluteUrl(video?.thumbnail)} controls autoPlay className="w-full h-full" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-white/50 text-sm">Video source unavailable</div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
